import { render, staticRenderFns } from "./CenterBottom.vue?vue&type=template&id=c67bef4c&scoped=true"
import script from "./CenterBottom.vue?vue&type=script&lang=js"
export * from "./CenterBottom.vue?vue&type=script&lang=js"
import style0 from "./CenterBottom.vue?vue&type=style&index=0&id=c67bef4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67bef4c",
  null
  
)

export default component.exports